// extracted by mini-css-extract-plugin
module.exports = {"list":"lawyer_keywords-module__list--3WPuj","item":"lawyer_keywords-module__item--3n8-j"};